import { Box, Button, Card, Column, Table } from '@palmetto/palmetto-components';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import { FundType, FundTypesLabels, UserPermissions } from 'types';

import { useGetFundsQuery } from '../../services/funds';
import RequirePermissions from '../auth/requirePermissions';
import { MainContainer } from '../MainContainer';
import PageHeader from '../PageHeader';

import { CreateFundModal } from './CreateFundModal';

export function Funds() {
  const { data: fundData = [], isFetching: isFundDataFetching } = useGetFundsQuery({});
  const [isCreateFundModalOpen, setIsCreateFundModalOpen] = useState(false);

  const columnConfig = [
    {
      heading: 'Name',
      dataKey: 'description',
      render: (_cell: any, row: any) => <Link to={`/admin/funds/${row.fundKey}`}>{row.description}</Link>,
    },
    {
      heading: 'Type',
      dataKey: 'fundType',
      render: (_cell: any, row: any) => <Box>{FundTypesLabels[row.fundType as FundType]}</Box>,
      width: 200,
    },
    {
      heading: 'Tranches',
      dataKey: 'trancheCount',
      width: 200,
    },
  ];

  return (
    <>
      <Helmet>
        <title>Funds</title>
      </Helmet>
      <MainContainer>
        <PageHeader title="Funds">
          <RequirePermissions permissions={[UserPermissions.lightReachPaymentAdmin]}>
            <Button variant="primary" size="md" onClick={() => setIsCreateFundModalOpen(true)}>
              Create Fund
            </Button>
          </RequirePermissions>
        </PageHeader>
        <Card padding="sm">
          {fundData.length > 0 ? (
            <Table
              rowKey="fundKey"
              columns={columnConfig as Column[]}
              rows={fundData || []}
              isLoading={isFundDataFetching}
              isScrollable={{
                x: true,
              }}
            />
          ) : (
            <Box padding="xl" textAlign="center">
              No funds found
            </Box>
          )}
        </Card>
        <CreateFundModal isModalOpen={isCreateFundModalOpen} closeModal={() => setIsCreateFundModalOpen(false)} />
      </MainContainer>
    </>
  );
}
